import { render, staticRenderFns } from "./MemoryBoardPage.vue?vue&type=template&id=397161be&scoped=true&"
import script from "./MemoryBoardPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MemoryBoardPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MemoryBoardPage.vue?vue&type=style&index=0&id=397161be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397161be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397161be')) {
      api.createRecord('397161be', component.options)
    } else {
      api.reload('397161be', component.options)
    }
    module.hot.accept("./MemoryBoardPage.vue?vue&type=template&id=397161be&scoped=true&", function () {
      api.rerender('397161be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/memorial/MemoryBoardPage/MemoryBoardPage.vue"
export default component.exports